import {CREATE_FROM_SCRATCH_ID} from './types';
import type {EmailComposerFormSequenceState} from './types';

type InitialContent = {
    subject?: string;
    plaintextBody?: string;
    body?: string;
};

/**
 * Helper function to create a "from scratch" template
 *
 * Optionally takes in some initial content for the subject and body
 *
 * @param  {Object} user        - User fragment, containing info about the signature
 * @param  {Object} initialContent  - Optional pieces of info like subject/body
 * @return {Object} A fully-fledged email sequence template object
 */
export function createFromScratchTemplate(
    user: {
        emailSignature: string | null | undefined;
    },
    initialContent: InitialContent | null = {},
    includeSignature = true
): EmailComposerFormSequenceState {
    const signature = includeSignature ? getMessageBodyFromUserSignature(user.emailSignature) : '';
    const body =
        initialContent && initialContent.body ? `${initialContent.body}${signature}` : signature;

    return {
        id: CREATE_FROM_SCRATCH_ID,
        name: 'Create from scratch',
        isShared: false,
        creatorUserId: null,
        isMaterialized: false,
        emailTemplates: {
            [CREATE_FROM_SCRATCH_ID]: {
                position: 0,
                id: CREATE_FROM_SCRATCH_ID,
                // @ts-expect-error
                name: 'Create from scratch',
                subject: '',
                plaintextBody: '',
                sendDelay: null,
                delay: null,
                expectedSendTime: 0,
                sendAsReply: false,
                ...initialContent,
                body,
            },
        },
    };
}

function getMessageBodyFromUserSignature(signature?: string | null) {
    if (!signature) {
        return '';
    }

    // Add three lines of spacing so it looks better when we
    // display their signature in this creator
    const threeLinesSpacing = '<p><br></p><p><br></p><p><br></p>';

    return `${threeLinesSpacing}${signature}`;
}
